import React from 'react';
import { FaHistory } from 'react-icons/fa';
import BaseModal from '../common/BaseModal';

const PriceHistoryModal = ({
  show,
  product,
  priceHistory,
  onClose,
}) => {
  if (!product) return null;

  const footerButtons = (
    <button type="button" className="btn btn-secondary" onClick={onClose}>
      Zamknij
    </button>
  );

  return (
    <BaseModal
      isOpen={show}
      onClose={onClose}
      title={<><FaHistory className="me-2" />Historia cen - {product.nazwa}</>}
      size="lg"
      footer={footerButtons}
    >
      <div className="mb-3">
        <strong>Kod produktu:</strong> {product.kod_produktu}<br />
        <strong>EAN:</strong> {product.ean || 'Brak'}<br />
        <strong>Aktualna cena:</strong> {
          product.hasSpecialPrice ?
            `${parseFloat(product.specialPriceBrutto || 0).toFixed(2)} zł (specjalna)` :
            `${parseFloat(product.cena_sprzedazy_brutto || 0).toFixed(2)} zł (domyślna)`
        }
      </div>

      {priceHistory.length > 0 ? (
        <div style={{ overflowX: 'auto' }}>
          <table style={{
            width: '100%', fontSize: '0.75rem',
            borderCollapse: 'separate', borderSpacing: 0
          }}>
            <thead style={{
              backgroundColor: 'var(--bg)',
              borderBottom: '2px solid var(--border)'
            }}>
              <tr style={{ fontSize: '0.7rem' }}>
                <th style={{ padding: '0.5rem', fontWeight: '600', color: 'var(--text-secondary)' }}>Data</th>
                <th style={{ padding: '0.5rem', fontWeight: '600', color: 'var(--text-secondary)' }}>Cena przed</th>
                <th style={{ padding: '0.5rem', fontWeight: '600', color: 'var(--text-secondary)' }}>Cena po</th>
                <th style={{ padding: '0.5rem', fontWeight: '600', color: 'var(--text-secondary)' }}>Typ zmiany</th>
                <th style={{ padding: '0.5rem', fontWeight: '600', color: 'var(--text-secondary)' }}>Użytkownik</th>
                <th style={{ padding: '0.5rem', fontWeight: '600', color: 'var(--text-secondary)' }}>Powód</th>
              </tr>
            </thead>
            <tbody>
              {priceHistory.map((entry, index) => (
                <tr key={entry.id} style={{
                  backgroundColor: index % 2 === 0 ? 'var(--bg)' : 'var(--card-bg)' ,
                  borderBottom: '1px solid var(--border)'
                }}>
                  <td style={{ padding: '0.5rem' }}>
                    <div style={{ fontSize: '0.7rem' }}>
                      {new Date(entry.date).toLocaleString('pl-PL')}
                    </div>
                  </td>
                  <td style={{ padding: '0.5rem' }}>
                    <div style={{ fontSize: '0.75rem', fontWeight: '600' }}>
                      {parseFloat(entry.old_price_brutto || 0).toFixed(2)} zł
                    </div>
                    <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)' }}>
                      netto: {parseFloat(entry.old_price_netto || 0).toFixed(2)} zł
                    </div>
                  </td>
                  <td style={{ padding: '0.5rem' }}>
                    <div style={{ fontSize: '0.75rem', fontWeight: '600', color: 'var(--success)' }}>
                      {parseFloat(entry.new_price_brutto || 0).toFixed(2)} zł
                    </div>
                    <div style={{ fontSize: '0.65rem', color: 'var(--text-muted)' }}>
                      netto: {parseFloat(entry.new_price_netto || 0).toFixed(2)} zł
                    </div>
                  </td>
                  <td style={{ padding: '0.5rem' }}>
                    <span style={{
                      padding: '0.125rem 0.375rem', fontSize: '0.6rem',
                      backgroundColor: entry.change_type === 'manual' ? 'var(--info)' : 'var(--info)',
                      color: '#fff' , borderRadius: '0.25rem', fontWeight: '600'
                    }}>
                      {entry.change_type === 'manual' ? 'Ręczna' : 'Masowa'}
                    </span>
                  </td>
                  <td style={{ padding: '0.5rem', fontSize: '0.75rem' }}>{entry.user}</td>
                  <td style={{ padding: '0.5rem', fontSize: '0.7rem' }}>{entry.reason}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center py-4">
          <FaHistory className="fa-2x text-muted mb-2" />
          <p className="text-muted">Brak historii zmian cen dla tego produktu</p>
        </div>
      )}
    </BaseModal>
  );
};

export default PriceHistoryModal;
